<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container" v-if="role === 'admin'">
      <div class="breadCrumbsContainer" style="display: flex;">
        ログイン履歴
      </div>

      <div class="row" style="margin-bottom: 0px;">
        <p class="inputTitle condition" style="min-width: 140px; max-width: 140px">IPアドレス</p>
        <multiselect
          v-model="ipAddressCondition"
          :options="ipAddressOptions"
          :multiple="true"
          :taggable="true"
          label="name"
          track-by="code"
          placeholder="検索したいIPアドレスを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          @tag="addIpAddressTag"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
      </div>


      <div class="searchBtn" @click="search()">検索</div>

      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= conditionRow.length">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{conditionRow.length}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{conditionRow.length}} / {{conditionRow.length}} 件
        </div>
      </div>
      <vue-good-table
        :columns='columns'
        :rows='conditionRow'
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          mode: 'pages',
          perPage: 100,
          position: 'top',
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: '次へ',
          prevLabel: '前へ',
          rowsPerPageLabel: '表示する行数',
          ofLabel: '/',
          pageLabel: 'ページ',
          allLabel: 'All',
        }"
        @on-page-change="onPageChange"
        v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'type'" style="display: flex;">
            <div class="registered" v-if="props.formattedRow.type===1" style="margin: 10px auto 0px auto;">
                ログイン
            </div>
            <div class="registered" v-else-if="props.formattedRow.type===0" style="background-color: #e94b35;margin: 10px auto 0px auto;">
                ログアウト
            </div>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
          <span v-if="props.column.field === 'name'" style="display: flex;">
            <div class="appendId" v-if="props.formattedRow.userId">{{props.formattedRow.userId}}</div>
          </span>
        </template>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
      <button type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && conditionRow.length > csvLimit"
        v-bind:class="{
          disabled: !csvDlFlg && conditionRow.length > csvLimit,
          active: csvDlFlg && conditionRow.length <= csvLimit
        }"
      >
        表示中のデータをCSV形式でダウンロード
      </button>
      <div style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import ApiClient from '../services/ApiClient';
import common from '../services/common';
import moment from 'moment';
import VCalendar from 'v-calendar';
import { VueLoading } from 'vue-loading-template';
import cloneDeep from 'lodash/cloneDeep';

export default {
  title: 'ログイン履歴',
  name: 'loginLog',
  components: {
    VueGoodTable,
    VueLoading,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      // 検索項目用
      ipAddressOptions: [],
      ipAddressCondition: [],

      columns: [
        {
          label: '日時',
          field: 'created',
          sortable: true,
          formatFn: this.callDateTimeFormat,
          width: '140px',
        },
        {
          label: '種別',
          field: 'type',
          sortable: true,
          width: '90px',
        },
        {
          label: 'ユーザー',
          field: 'name',
          sortable: true,
          width: '280px',
        },
        {
          label: 'IPアドレス',
          field: 'ip',
          width: '120px',
          formatFn: common.ipAddressFormat,
        },
        {
          label: 'ユーザーエージェント',
          field: 'ua',
          sortable: false,
          width: '500px',
        },
        {
          label: '内部ID',
          field: 'id',
          hidden: true,
        },
        {
          label: 'ユーザーID',
          field: 'userId',
          hidden: true,
        },
      ],
      rows: [],
      conditionRow: [],
      selectRow: {},
      // データ取得時ローディングフラグ
      getLodingFlg: false,
      // データ取得時エラーフラグ
      getErrorFlg: false,
      csvDlFlg: false,
      errorMessage: '',
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // CSV取得上限
      csvLimit: 10000,
    };
  },
  // 初期処理
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // ログイン履歴一覧取得API呼出
      const restResourceService = new ApiClient();
      if (this.id !== '-') {
        this.rows = await restResourceService.getLoginLog(this.id);
      } else {
        this.rows = await restResourceService.getLoginLogs();
      }
      // 初期テーブルデータをセット
      this.conditionRow = this.rows;
      // 検索条件を取得
      this.ipAddressCondition = common.getUrlParam('ipAddress', 0);
      // 検索処理呼出
      this.search();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // IPアドレス検索用タグ追加処理
    addIpAddressTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };

      this.ipAddressCondition.push(tag);
      this.ipAddressOptions.push(tag);
    },
    // 検索ボタン押下時
    search() {
      this.setCondition();
      // 検索条件をURLに詰める
      common.setUrlParam('ipAddress', this.ipAddressCondition, 0);
      // テーブルが空の場合CSVダウンロードを非活性
      this.csvDlFlg = (this.conditionRow.length > 0) ? true : false;
    },
    // 一覧上部の検索条件を一覧へ反映
    setCondition() {
      if (this.ipAddressCondition.length === 0) {
        // 検索条件がない場合、初期データを書き戻す
        this.conditionRow = this.rows;
        return;
      }
      let newRows = [];
      let tempRows = this.rows;
      this.conditionRow = [];

      // 検索条件：IPアドレス(部分一致)
      if (this.ipAddressCondition.length !== 0) {
        newRows = [];
        this.ipAddressCondition.forEach(
          (ip) => {
            const tempRow = tempRows.filter((v) =>
              v.ip.match(ip.name),
            );
            if (tempRow.length !== 0) {
              Array.prototype.push.apply(newRows, tempRow);
            }
          },
        );
        // 重複チェック
        this.conditionRow = Array.from(
          new Map(newRows.map((row) => [row.id, row])).values()
        );
        tempRows = this.conditionRow;
      }
      this.csvDlFlg  = (this.conditionRow.length > 0) ? true : false;
    },
    // 日時値を日時（YYYY年MM月DD日）に変換
    callDateTimeFormat(value) {
      return common.dateTimeFormatLog(value);
    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      const columns = this.columns;
      const rows = cloneDeep(this.conditionRow);
      for (const row of rows) {
        row.created = this.callDateTimeFormat(row.created);
      }
      // ファイル名用の現在日時
      const currentDate = new Date().getTime();
      const date = await common.getToday(currentDate);
      const fileName = 'ログインログ一覧'+date;
      common.outputCsv(columns, rows, fileName);
    },
    // 現在ページ更新
    onPageChange(params) {
      this.currentPage = params.currentPage;
      common.scrollTop();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
